import useZustandStore from "../zustandStore/useZustandStore";

const useUserRoles = () => {
  const currentUser = useZustandStore((val) => val?.currentUser);
  const isLoggedIn = !!currentUser?.roles;
  const isPending = isLoggedIn && currentUser?.status === "pending";
  const isAdmin = isLoggedIn && currentUser?.status === "approved";
  const isExternal = isLoggedIn && currentUser?.status === "approved";
  return {
    isAdmin,
    isExternal,
    isPending,
    isLoggedIn,
  };
};

export default useUserRoles;
